export interface FollowUpTextProps {
  customerName: string;
  personalMessage?: string;
  senderName?: string;
}

const firstName = (fullName: string): string => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  return parts[0] || 'there';
};

export const followUpText = async (
  params: FollowUpTextProps,
): Promise<{ body: string }> => {
  const { customerName, personalMessage, senderName } = params;
  const greetingName = firstName(customerName);
  const personal = (personalMessage || '').trim();

  const sections = [`Hey ${greetingName}, just following up.`];

  if (personal) {
    sections.push(personal);
  } else {
    sections.push(
      "Wanted to make sure nothing's holding you up. Happy to answer questions any time.",
    );
  }

  sections.push(
    senderName
      ? `– ${senderName}, Optic Truck Works`
      : '– The Optic Truck Works Team',
  );

  return { body: sections.join('\n\n') };
};
